export { default as oscar } from './oscar_video.mp4'
